import scene0 from "@/components/scenes/global/scene0.vue";
import scene1 from "@/components/scenes/2022/scene1.vue";
import scene2 from "@/components/scenes/2022/scene2.vue";
import scene3 from "@/components/scenes/2022/scene3.vue";
import scene4 from "@/components/scenes/2022/scene4.vue";
import scene9 from "@/components/scenes/2022/scene9.vue";
import scene8 from "@/components/scenes/2022/scene8.vue";
import scene11 from "@/components/scenes/2022/scene11.vue";
import scene7 from "@/components/scenes/2022/scene7.vue";
import scene10 from "@/components/scenes/2022/scene10.vue";
import scene6 from "@/components/scenes/2022/scene6.vue";
import scene5 from "@/components/scenes/2022/scene5.vue";
import scene12 from "@/components/scenes/2022/scene12.vue";
import scene13 from "@/components/scenes/2022/scene13.vue";
import scene14 from "@/components/scenes/2022/scene14.vue";
import scene15 from "@/components/scenes/2022/scene15.vue";
import scene16 from "@/components/scenes/2022/scene16.vue";
import scene17 from "@/components/scenes/2022/scene17.vue";
import scene18 from "@/components/scenes/2022/scene18.vue";
import scene19 from "@/components/scenes/2022/scene19.vue";
import scene20 from "@/components/scenes/2022/scene20.vue";
import scene21 from "@/components/scenes/2022/scene21.vue";
import scene22 from "@/components/scenes/2022/scene22.vue";
import scene23 from "@/components/scenes/2022/scene23.vue";
import scene24 from "@/components/scenes/2022/scene24.vue";

const scenes = {
    scene0,
    scene1,
    scene2,
    scene3,
    scene4,
    scene5,
    scene6,
    scene7,
    scene8,
    scene9,
    scene10,
    scene11,
    scene12,
    scene13,
    scene14,
    scene15,
    scene16,
    scene17,
    scene18,
    scene19,
    scene20,
    scene21,
    scene22,
    scene23,
    scene24
}
    /*{
    scene0,
    scene1,
    scene2,
    scene3,
    scene4,
    scene5,
    scene6,
    scene7,
    scene8,
    scene9,
    scene10,
    scene11,
    scene12,
    scene13
}*/
export default scenes
